var _excluded = ["id", "label", "title", "subtitle", "description", "price", "button", "renewalPayment", "parameters", "footer", "promoText", "isLoading", "isTrialBox", "outerFooter", "hasDarkMode", "customTextColor", "backgroundImage", "isGridMode", "hasExtraParameter"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";
import { useTheme } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import ConditionalWrapper from "../../../helpers/ConditionalWrapper";
import ButtonAtm from "../../atoms/ButtonAtm";
import PlaceholderAtm from "../../atoms/PlaceholderAtm";
import TextAtm from "../../atoms/TextAtm";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import TooltipMol from "../TooltipMol";
import { darkModeBackground, footerBackground, mainBackground, promoBoxColor, promoTextTypography } from "./PackageBoxSlimMol.settings";
import { Footer, Header, Main, ParametersGroup as ParametersGroupsStyled, ParameterCta, ParameterLabel, ParameterLabelWrapper, ParameterValue, ParameterWrapper, PromoTextContainer, Wrapper, Label, IconContainer, GridWrapper, ButtonContainer } from "./PackageBoxSlimMol.styled";
import RenewalPayment, { renewalPaymentTypography } from "./RenewalPayment";
export var ParametersGroup = function ParametersGroup(_ref) {
  var title = _ref.title,
    hasNoBorder = _ref.hasNoBorder,
    children = _ref.children,
    isTrialBox = _ref.isTrialBox;
  return /*#__PURE__*/React.createElement(ParametersGroupsStyled, {
    columns: 1,
    gutterSpace: 2,
    $title: title,
    $hasNoBorder: hasNoBorder,
    $isTrialBox: isTrialBox
  }, children);
};
export var ParameterItem = function ParameterItem(_ref2) {
  var label = _ref2.label,
    tooltip = _ref2.tooltip,
    value = _ref2.value,
    cta = _ref2.cta,
    isInactive = _ref2.isInactive,
    isTrialBox = _ref2.isTrialBox,
    icon = _ref2.icon;
  return /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ParameterWrapper, {
    $isTrialBox: isTrialBox
  }, /*#__PURE__*/React.createElement(ParameterLabelWrapper, {
    $hasTooltip: !!tooltip,
    $isTrialBox: isTrialBox
  }, icon ? /*#__PURE__*/React.createElement(IconContainer, null, icon) : null, /*#__PURE__*/React.createElement(ParameterLabel, {
    typography: "small2",
    emphasis: isInactive ? "half" : "high",
    hasLineThrough: isInactive,
    data: label
  }), tooltip ? /*#__PURE__*/React.createElement(TooltipMol, {
    isOverlappingRelativeContainer: true
  }, tooltip) : null), value ? /*#__PURE__*/React.createElement(ParameterValue, {
    typography: "small2",
    emphasis: isInactive ? "low" : "high",
    hasLineThrough: isInactive,
    data: value
  }) : null), cta ? /*#__PURE__*/React.createElement(ParameterCta, null, cta) : null);
};
export var priceTypography = {
  small: "sgiant",
  "default": "giant"
};
export var priceAffixTypography = {
  small: "tiny1",
  "default": "xsmall1"
};
var getTypographyLineHeight = function getTypographyLineHeight(theme, typography, isSmallOnly) {
  var typographyName;
  if (_typeof(typography) === "object") {
    if (isSmallOnly) {
      typographyName = typography.small;
    } else {
      typographyName = typography["default"];
    }
  } else {
    typographyName = typography;
  }
  var typographyObject = theme.typography[typographyName];
  if (isSmallOnly && typographyObject.mobile && typographyObject.mobile.lineHeightSpace) {
    return typographyObject.mobile.lineHeightSpace;
  }
  return theme.typography[typographyName].lineHeightSpace;
};
var PriceLoading = function PriceLoading() {
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 2
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: 1
  }, /*#__PURE__*/React.createElement(PlaceholderAtm, {
    widthSpace: {
      small: 8,
      medium: 15,
      large: 15
    },
    heightSpace: getTypographyLineHeight(theme, priceTypography, true)
  })), /*#__PURE__*/React.createElement(PlaceholderAtm, {
    widthSpace: {
      small: 9,
      medium: 12,
      large: 12
    },
    heightSpace: getTypographyLineHeight(theme, priceAffixTypography, true)
  })), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: 1
  }, /*#__PURE__*/React.createElement(PlaceholderAtm, {
    widthSpace: {
      small: 8,
      medium: 15,
      large: 15
    },
    heightSpace: getTypographyLineHeight(theme, priceTypography, false)
  })), /*#__PURE__*/React.createElement(PlaceholderAtm, {
    widthSpace: {
      small: 9,
      medium: 12,
      large: 12
    },
    heightSpace: getTypographyLineHeight(theme, priceAffixTypography, false)
  }))));
};
function PackageBoxSlimMol(_ref3) {
  var id = _ref3.id,
    label = _ref3.label,
    title = _ref3.title,
    subtitle = _ref3.subtitle,
    description = _ref3.description,
    price = _ref3.price,
    button = _ref3.button,
    renewalPayment = _ref3.renewalPayment,
    parameters = _ref3.parameters,
    footer = _ref3.footer,
    promoText = _ref3.promoText,
    isLoading = _ref3.isLoading,
    isTrialBox = _ref3.isTrialBox,
    outerFooter = _ref3.outerFooter,
    hasDarkMode = _ref3.hasDarkMode,
    customTextColor = _ref3.customTextColor,
    backgroundImage = _ref3.backgroundImage,
    isGridMode = _ref3.isGridMode,
    hasExtraParameter = _ref3.hasExtraParameter,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var theme = useTheme();
  var onColorValue = customTextColor || mainBackground;
  var priceElement = isLoading ? /*#__PURE__*/React.createElement(PriceLoading, null) : price;
  var renewalProps = {
    id: id,
    isLoading: isLoading,
    renewalPayment: renewalPayment
  };
  return /*#__PURE__*/React.createElement(GridWrapper, {
    $isGridMode: isGridMode
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    $isGridMode: isGridMode
  }, restProps), promoText ? /*#__PURE__*/React.createElement(PromoTextContainer, {
    $hasPromoText: !!promoText
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: promoBoxColor
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: promoTextTypography,
    align: "center"
  }, promoText))) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Main, {
    $hasDarkMode: !!hasDarkMode,
    $backgroundImage: backgroundImage,
    $isTrialBox: isTrialBox,
    $isGridMode: isGridMode,
    $hasPromoText: !!promoText,
    $hasExtraParameter: !!hasExtraParameter
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: hasDarkMode ? darkModeBackground : onColorValue
  }, /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 4,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "big4"
  }, title), subtitle ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small1"
  }, subtitle) : null), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small1"
  }, description))), /*#__PURE__*/React.createElement("div", null, priceElement), /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: !!isTrialBox,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
        value: mainBackground
      }, children);
    }
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    $isTrialBox: isTrialBox
  }, /*#__PURE__*/React.createElement(ButtonAtm, _extends({
    isExpanded: true,
    isDisabled: isLoading,
    "data-test-id": button !== null && button !== void 0 && button.dataTestId ? button.dataTestId : "product_box_select_button"
  }, button), button === null || button === void 0 ? void 0 : button.text)), renewalPayment ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(RenewalPayment, _extends({}, renewalProps, {
    heightSpace: getTypographyLineHeight(theme, renewalPaymentTypography, true)
  }))), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(RenewalPayment, _extends({}, renewalProps, {
    heightSpace: getTypographyLineHeight(theme, renewalPaymentTypography, false)
  })))) : /*#__PURE__*/React.createElement("div", null), parameters))), !isTrialBox && footer ? /*#__PURE__*/React.createElement(Footer, {
    $hasDarkMode: !!hasDarkMode,
    $hasPromoText: !!promoText
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: hasDarkMode ? darkModeBackground : footerBackground
  }, footer)) : undefined), !isTrialBox && outerFooter ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 2.5
  }, /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "center"
  }, outerFooter)) : undefined);
}
export default PackageBoxSlimMol;